"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../NotificationItem"));
var ManaMainnet_1 = __importDefault(require("../../Icons/Notifications/ManaMainnet"));
var ManaPoly_1 = __importDefault(require("../../Icons/Notifications/ManaPoly"));
var schemas_1 = require("@dcl/schemas");
var utils_1 = require("../utils");
var i18N = {
    en: {
        description_1: "You earned ",
        description_2: "for selling ",
        title: 'Royalties Earned'
    },
    es: {
        description_1: "Ganaste ",
        description_2: "por vender ",
        title: 'Regalias ganadas'
    },
    zh: {
        description_1: "\u60A8\u901A\u8FC7\u51FA\u552E ",
        description_2: "\u8D5A\u53D6\u4E86 ",
        title: '所得版税'
    }
};
var RoyaltiesEarnedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: {
            url: notification.metadata.image,
            rarity: notification.metadata.rarity,
            icon: notification.metadata.network === 'ethereum' ? (react_1.default.createElement(ManaMainnet_1.default, null)) : (react_1.default.createElement(ManaPoly_1.default, null))
        }, timestamp: notification.timestamp, isNew: !notification.read },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        locale == 'zh' ? (react_1.default.createElement("p", { className: "dcl notification-item__content-description" },
            i18N[locale].description_1,
            react_1.default.createElement("span", null,
                react_1.default.createElement("a", { href: notification.metadata.link, style: {
                        color: "".concat(schemas_1.Rarity.getColor(notification.metadata.rarity)),
                        textDecoration: 'underline'
                    } }, notification.metadata.nftName)),
            ' ',
            i18N[locale].description_2,
            (0, utils_1.formatMana)(notification.metadata.royaltiesCut),
            " MANA")) : (react_1.default.createElement("p", { className: "dcl notification-item__content-description" },
            i18N[locale].description_1,
            (0, utils_1.formatMana)(notification.metadata.royaltiesCut),
            " MANA",
            ' ',
            i18N[locale].description_2,
            react_1.default.createElement("span", null,
                react_1.default.createElement("a", { href: notification.metadata.link, style: {
                        color: "".concat(schemas_1.Rarity.getColor(notification.metadata.rarity)),
                        textDecoration: 'underline'
                    } }, notification.metadata.nftName))))));
};
exports.default = RoyaltiesEarnedNotification;
